import actions from "./actions";

const initState = {
    auditResult: [],
    loading: false,
    error: null,
    buttonLoading: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_AUDIT_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
                buttonLoading :true
            };
        case actions.GET_AUDIT_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                auditResult: action.auditResult,
                buttonLoading :false
            };
        case actions.GET_AUDIT_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                buttonLoading :false
            };
        default:
            return state;
    }
}